import React from 'react';

const DarkBackground = () => {
  return (
    <div className="fixed inset-0 w-full h-full bg-gray-900" style={{ zIndex: -10 }}>
      {/* Degradado sutil */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 to-gray-800"></div>
      
      {/* Puntos sutiles tipo constelación */}
      <div className="absolute inset-0 opacity-30" 
        style={{
          backgroundImage: `radial-gradient(white 1px, transparent 0)`,
          backgroundSize: '50px 50px'
        }}
      />
      
      {/* Efectos de luces tenues */}
      <div className="absolute top-1/5 right-1/4 w-96 h-96 rounded-full bg-blue-500/5 blur-3xl"></div>
      <div className="absolute bottom-1/4 left-1/5 w-64 h-64 rounded-full bg-indigo-500/5 blur-3xl"></div>
      
      {/* Líneas horizontales sutiles */}
      <div className="absolute top-1/3 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent"></div>
      <div className="absolute top-2/3 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent"></div>
    </div>
  );
};

export default DarkBackground; 